import { DocumentScannerForm } from '@/features/document-scanner'
import { ToolPageShell } from '@/shared/seo'

export function SkanerDokumentovPage() {
  return <ToolPageShell utilityKey="document-scanner"><DocumentScannerForm /></ToolPageShell>
}
